import { all, fork, takeEvery } from 'redux-saga/effects';
import { types } from './reducer';
import pagination from '@iso/lib/helpers/pagination';
import BrandService from '@iso/services/SettingsService/ProductService/BrandService';

function* watchFetchProductBrands() {
    yield takeEvery(
        types.REQUEST_FETCH_PRODUCT_BRANDS,
        pagination('productBrands').saga(BrandService),
    );
}

function* paginationSaga() {
    yield all([
        fork(watchFetchProductBrands),
    ]);
}

export default paginationSaga;